<template>
  <div v-loading="loading" class="auth-login h-full w-full">
    <LoginFaildDialog v-if="faild" />
  </div>
</template>

<script>
import { LoginByUserAuthGrant } from '@/api/auth'
import { getDevOrgCode, resolveStoreOrg } from '@/utils/app'
import LoginFaildDialog from './components/LoginFaildDialog.vue'
export default {
  name: 'AuthLogin',
  components: { LoginFaildDialog },
  data: () => ({
    loading: true,
    faild: false,
  }),
  async mounted () {
    // 開發環境優先用 getDevOrgCode()，避免在 localhost 上拿到 'localhost' 當 orgCode
    const hostOrg = resolveStoreOrg({ overrideCode: getDevOrgCode() })
    if (hostOrg.kind !== 'org') {
      // 入口或找不到組織的網址不能做授權登入
      this.loading = false
      this.faild = true
      return
    }
    const code = this.$route.query.code
    const [res, err] = await LoginByUserAuthGrant({
      orgCode: hostOrg.code,
      code,
    })
    if (err) {
      this.loading = false
      this.faild = true
      return
    }
    this.$store.commit('auth/SET_TOKEN', res.token)
    this.$router.replace('/')
  },
}
</script>

<style lang="postcss" scoped>

</style>
